export default "__VITE_ASSET__Dnt7KMjN__"